import { selectMetadataById } from '../../redux/features/selectors/selectMetadataById.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { ReferenceBarPropertyMetadataByID } from '../types.ts';
import { getTkv2MetadataByID } from './useNewTkv2ReferenceBarUserInterface.ts';
import { useTkv2NullableOrderContext } from './useTkv2NullableControllerOrder.ts';

export const useMetadataByID = (): ReferenceBarPropertyMetadataByID => {
  const orderContext = useTkv2NullableOrderContext();
  const tkv2MetadataByID = getTkv2MetadataByID(orderContext);
  const metadataById = useAppSelector(selectMetadataById);

  return orderContext ? tkv2MetadataByID : metadataById;
};
